module.exports = __webpack_public_path__ + "img/SCADA PP Line A.5f0b38e2.jpg";